import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Check, Copy } from '@/components/icons/barrel';

import { Button, ButtonProps } from './button';

type Props = {
  children: string;
  text?: string;
  variant?: 'icon' | 'button';
  buttonProps?: ButtonProps;
};

export default function Copyable({
  children,
  text,
  variant = 'icon',
  buttonProps,
}: Props) {
  const { t } = useTranslation();

  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => {
    if (!isCopied) return;
    const timeout = window.setTimeout(() => setIsCopied(false), 3000);
    return () => {
      window.clearTimeout(timeout);
    };
  }, [isCopied]);

  const handleCopy = () => {
    navigator.clipboard.writeText(children);
    setIsCopied(true);
  };

  if (variant === 'icon') {
    return isCopied ? (
      <Check size={14} strokeWidth={2.5} />
    ) : (
      <Copy
        size={14}
        strokeWidth={2}
        className="cursor-pointer transition-colors hover:text-vestgrey-100"
        onClick={handleCopy}
      />
    );
  }

  return (
    <Button {...buttonProps} onClick={handleCopy}>
      {isCopied ? (
        <Check size={14} strokeWidth={2.5} />
      ) : (
        <Copy size={14} strokeWidth={2} />
      )}
      {text ?? t('shared.copy')}
    </Button>
  );
}
